<template>
  <div class="header">
    <div class="header-left">
      <img src="../assets/img/logo.png" alt="" />
      <p>鼎函统一登录入口{{ environmentName }}</p>
    </div>
<!--    <div class="header-right">
      <img :src="local.wea_img" alt="" />
      <div style="">
        <div>
          <span>{{ local.city }}</span>
          <span style="margin-left: 10px;">{{ local.wea +'&nbsp &nbsp' +local.tem+'℃' }}</span>
        </div>
        <div>{{ local.date }}</div>
      </div>
    </div>-->
  </div>
</template>

<script>
export default {
  name: "Header",
  props: {
    environment: String,
  },
  computed: {
    environmentName() {
      const map = {
        dev: "(测试环境)",
        prod: "", // 生产环境
        test: "(新测试环境)",
      };
      return map[this.environment] || "";
    }
  },
  data() {
    return {
      show: true,
      local: {
        // ip地址所在城市
        city: "",
        // 所在城市温度
        tem: "",
        // 天气类型
        wea: "",

        wea_img: "",
        // 时
        date: "",
       
      },
      timeId: "",
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.getLocalCity();
    },
    getLocalCity() {
      var data = {
        key: "5NOBZ-XIYWU-GVLVV-GJ2BI-FFTTK-WVFTU",
      };
      var url = "https://apis.map.qq.com/ws/location/v1/ip"; //这个就是地理位置信息的接口
      data.output = "jsonp";
      this.$jsonp(url, data)
        .then((res) => {
          this.local.city = res.result.ad_info.city;
          // 根据城市，获取当前天气和时间（在此先预留获取天气方法，完成后取消注释）
          // this.getLocalWeather(res.result.ip); // 这里就是调用下面的那个
          // this.getLocalWeatherByCode(res.result.ad_info.adcode); // 这里就是调用下面的那个
          return res;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 通过adcode获取当地时间和天气
    getLocalWeatherByCode(adcode){
      if (adcode) {
        this.$axios.get(`https://restapi.amap.com/v3/weather/weatherInfo?city=${adcode}&key=d086c35d8988ef025692949832821ae3`)
            .then((res) => {
              console.log("获取数据", res);
              let data = res.data
              // 获取当天数据
              this.local.wea =data.wea;
              this.local.wea_img = require('../assets/img/'+data.wea_img+'.png')  ;
              this.local.tem =data.tem;
              // 获取当前时间
              let newDate = new Date();
              this.local.date = newDate.getFullYear()+'年'+(newDate.getMonth()+1) +'月'+this.local.date + newDate.getDate()+'日'
              console.log( this.local.date)

              // 使用定时器，实时刷新城市、天气和时间
              // this.timeId = setTimeout(() => {
              //   this.getLocalCity(city);
              // }, 1000);
            }).catch(function (error) {
              this.show = false
              console.log(error);
            });
      }
    },
    // 获取当地时间和天气
    getLocalWeather(ip) {
      if (ip && ip !== "") {
        this.$axios
          .get(
            "https://v0.yiketianqi.com/free/day?appid=78177787&appsecret=DsdOp8vD&unescape=1&vue=1&ip=" +
              ip
          )
          .then((res) => {
            console.log("aaaaa:::", res);
            let data = res.data
            // 获取当天数据
            this.local.wea =data.wea;
            this.local.wea_img = require('../assets/img/'+data.wea_img+'.png')  ;
            this.local.tem =data.tem;
            // 获取当前时间
            let newDate = new Date();
            this.local.date = newDate.getFullYear()+'年'+(newDate.getMonth()+1) +'月'+this.local.date + newDate.getDate()+'日'
            console.log( this.local.date)
           
            // 使用定时器，实时刷新城市、天气和时间
            // this.timeId = setTimeout(() => {
            //   this.getLocalCity(city);
            // }, 1000);
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },
  },
};
</script>
<style scoped>
.header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 80px;
  /* background: #065cd5; */
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px;
  box-sizing: border-box;
}
.header-left {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  color: #fff;
}
.header-left img {
  margin-right: 10px;
  width: 50px;
}
.header-right {
  width: 300px;
  height: 100%;
  background: rgba(0, 0, 0, 0.25);
  display: flex;
  align-items: center;
  justify-content: flex-start;
  color: #fff;
}
.header-right img {
  width: 50px;
  height: 50px;
  margin-right: 20px;
}
</style>